import { HtmlComponent } from './../html-component';

// import html
import template from './toggle-component.hogan.html';

// js
import * as TSE from 'ts-events';

export class ToggleComponent extends HtmlComponent {
    private active: boolean = true;
    public change = new TSE.SyncEvent();

    constructor(parameters: {}) {
        super(template, parameters);
        this.jqueryElement.addClass('.toggle-component-disabled');
        this.initInteraction();
    }

    private initInteraction() {
        this.jqueryElement.click(() => {
            if (this.active) {
                this.disable();
                this.change.post('disabled');
            } else {
                this.enable();
                this.change.post('enabled');
            }
        });
    }

    public enable() {
        this.active = true;
        this.jqueryElement.find('.toggle-on').removeClass('toggle-option-disabled');
        this.jqueryElement.find('.toggle-off').addClass('toggle-option-disabled');
    }

    public disable() {
        this.active = false;
        this.jqueryElement.find('.toggle-off').removeClass('toggle-option-disabled');
        this.jqueryElement.find('.toggle-on').addClass('toggle-option-disabled');
    }
}
